//import liraries
import React, { Component, useState, useEffect, useRef } from "react";
import {View, Text, Image, TouchableOpacity, Linking, Platform} from "react-native";
import CustomInput from "../../common/CustomInput";
import CustomButton from "../../common/CustomButton";
import IconBack from "../../assets/images/icon_back.svg";
import applicationStyles from "../../styles/applicationStyles";
import PriceCard01 from "../../assets/images/fastag_price_card_01.png";
import PriceCard02 from "../../assets/images/fastag_price_card_02.png";
import PriceCard03 from "../../assets/images/fastag_price_card_03.png";
import PriceCard04 from "../../assets/images/fastag_price_card_04.png";
import PriceCard05 from "../../assets/images/fastag_price_card_05.png";
import PriceCard06 from "../../assets/images/fastag_price_card_05.png";
import PriceCard07 from "../../assets/images/fastag_price_card_07.png";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import {jwtDecode} from "jwt-decode";
import {  sendOtpApi,  validateOtpApplyNow,  getEncryptKey,  getPaymentData,  getAddress, changeAddress} from "../../api/apiManager";
import ModalAlert from "../../common/ModalAlert";
import { Encryption as  encrypt } from "../../utilities/Encryption";
import Countdown from "react-countdown";
import moment from "moment";
import useStyles from "./PaymentBreakup_Styles";
import { getConfigurations } from "../../api/serviceRequest";
export default function PaymentBreakup(props) {
  console.log("props PaymentBreakup",props)
  const amount = props.data?.priceBreakUpData?.card_breakup?.totalAmt
  const totalAmt = amount
  const otpPattern = /^\d{6}$/
  const styles = useStyles();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [otp, setOtp] = useState("");
  const [mobileOtpMsg, setMobileOtpMsg] = useState("");
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [changeAddressModalVisible, setChangeAddressModalVisible] = useState(false);
  const [pincode, setPincode] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState({});
  const [HTMLDATA, setHTMLDATA] = useState("");
  const [orderId, setOrderId] = useState("");
  const [timerEnable, setTimerEnable] = useState(false);
  const [changeAddressData, setChangeAddressData] = useState(false);
  const counterRef = useRef(null);
  const [timerState, setTimeState] = useState("");
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "", navigateScreen: "", actionButton: "", });

  const onCloseModal = () => { setAlertModalVisible(false);};
  useEffect(()=>{
    loadDefaultConfig()
  },[])
  const loadDefaultConfig = () => {
    
    getConfigurations().then((res)=>{
      if(res.statusCode == 200) {

        const ccavenueAccessCode =res?.data.find((configItem) => configItem.key == "ccavenue_access_code_ff_portal");
        const CC_AVENUE_URL =res?.data.find((configItem) => configItem.key == "CC_AVENUE_URL");

        if (CC_AVENUE_URL) {
          global.CC_AVENUE_URL = CC_AVENUE_URL.value;
        }
        
        if (ccavenueAccessCode) {
          global.ccavenueAccessCode = ccavenueAccessCode.value;
        }
      }
    }).catch((err)=>{
      global.maxUploadFileSizeInMB = 2
      global.kycMaxUploadFileSizeInMB = 1
    })
}

  useEffect(() => {
    getAddress(pincode)
      .then((res) => {
        console.log(res,"postal res")
        if (res && res[0]?.Status == "Success") {
          let PostOffice = res[0]?.PostOffice[0];
          setAddress(PostOffice);
          console.log(PostOffice);
        } else {   setAddress({}); }
      }).catch((err) => {
        console.log(err);
      });
  }, [pincode]);

  const updateCardImage = (key) => {
    switch (key) {
      case "VC4":
      case "VC20":
        return PriceCard01;
        break;
      case "VC5":
      case "VC9":
        return PriceCard02;
        break;
      case "VC6":
      case "VC8":
      case "VC11":
        return PriceCard03;
        break;
      case "VC7":
      case "VC10":
        return PriceCard04;
        break;
      case "VC12":
      case "VC13":
      case "VC14":
        return PriceCard05;
        break;
      case "VC15":
        return PriceCard06;
        break;
      case "VC16":
      case "VC17":
        return PriceCard07;
        break;
      default:
        return PriceCard01;
        break;
    }
  };

  useEffect(()=>{
    if(otpModalVisible){
      setTimeState({
        times: [ Date.now() + 5000, Date.now() + 12000, Date.now() + 17000, Date.now() + 22000,],
        currentTimeIndex: 0,
        currentTime: Date.now() + 60000,
      })
    }
  },[otpModalVisible])

  const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
    if (completed || isNaN(minutes)) {
      return (
        <>
          <Text>{"00:00"}</Text>
          <TouchableOpacity
            onPress={() => {
              setTimeState({
                times: [Date.now() + 5000, Date.now() + 12000, Date.now() + 17000, Date.now() + 22000 ],
                currentTimeIndex: 0,
                currentTime: Date.now() + 60000,
              });
              setTimeout(() => {api.start();}, 500);
              resendOTP();
            }}>
            <Text style={styles.resendTextStyle}>{"Resend"}</Text>
          </TouchableOpacity>
        </>
      ); }
    return (
      <>
        <Text> {minutes}:{seconds}</Text>
        <View><Text style={[styles.resendTextStyle, { color: "gray" }]}> {"Resend"} </Text></View>
      </>
    );};

  const completeTime = () => {
    if (timerState.times.length - 1 <= timerState.times.indexOf(timerState.currentTime))
      return;
    timerState.currentTimeIndex++;
    timerState.currentTime = new Date(timerState.times[timerState.currentTimeIndex + 1]);
  };

  const onChangeAddress = async () => {
    setLoading(true);
      let token = await AsyncStorageFunc.getData('TOKEN');
      let reqObj = {
        vrn: props?.data?.addVehicleData?.vrn,
        userId: token ? jwtDecode(token).mappedOrgId: "",
        pinCode: pincode,
        addressLn1: address1,
        addressLn2: address2,
        district:address.District !="" || address.District != undefined ? address?.District : props.data?.priceBreakUpData?.address?.city,
        state: address.State !="" || address.State != undefined ? address?.State : props.data?.priceBreakUpData?.address?.state,
        contactNo: mobileNumber,
      };
      changeAddress(reqObj)
        .then((res) => {
          console.log(res,'change address res');
          if (res.statusCode == 1014 || res.statusCode == 200) {
            setChangeAddressData(true)
            setChangeAddressModalVisible(false)
          } else if (res.statusCode == -1014 || res.statusCode == -1015 ||  res.statusCode == 500) {
            setAlertModal({title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK"});
            setAlertModalVisible(true);
            setChangeAddressData(false)
          }
        }).catch((err) => {
          setLoading(false);
          setAlertModal({ title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK"});
          setAlertModalVisible(true);
        });
  };

  const handleSubmit = async () => {
    setLoading(true);
    let token = await AsyncStorageFunc.getData("TOKEN");
    let reqObj = { type: "tagIssue", id: token ? jwtDecode(token).userCd :  "",};

    sendOtpApi(reqObj)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 200 || res.statusCode == 1003) {
          setMobileOtpMsg(res.message);
          setRequestId(res?.response?.otp);
          setOtpModalVisible(true);
        } else if (res.statusCode == -1001 || res.statusCode == -1003 || res.statusCode == 500 || res.statusCode < 0) {
          setOtpModalVisible(false);
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK"});
          setAlertModalVisible(true);
        }
      }).catch((err) => {
        setLoading(false);
        setOtpModalVisible(false);
        setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK" });
        setAlertModalVisible(true);
        if (err == "Error: Request failed with status code 401") {} else { }
      });};

  const resendOTP = async () => {
    setOtp("")
    setLoading(true);
    let token = await AsyncStorageFunc.getData("TOKEN");
    let reqObj = { type: "tagIssue", id: token ? jwtDecode(token).userCd : "",};
    setTimerEnable(false);
    sendOtpApi(reqObj)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 200 || res.statusCode == 1003) {
          setMobileOtpMsg(res.message);
          setRequestId(res?.response?.otp);
          setOtpModalVisible(true);
        } else if (res.statusCode == -1001 || res.statusCode == -1003 || res.statusCode == 500 || res.statusCode < 0 ) {
          setOtpModalVisible(false);
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK" });
          setAlertModalVisible(true);
        }
      }).catch((err) => {
        setLoading(false);
        setOtpModalVisible(false);
        setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK" });
        setAlertModalVisible(true);
        if (err == "Error: Request failed with status code 401") {} else {}
      }); };

  const validateOTP = async () => {
    setLoading(true);
    setTimerEnable(false)
    let token = await AsyncStorageFunc.getData("TOKEN");
    let reqObj = { requestId: requestId, otp: otp, type: "tagIssue", userId: token && token != "" && jwtDecode(token)?.mappedOrgId ? jwtDecode(token).mappedOrgId : "",};
    validateOtpApplyNow(reqObj)
      .then((res) => {
        setLoading(false);
        setOtp("");
        if (res.statusCode > 200 && res.statusCode != 500) {
          setOtpModalVisible(false);
          let reqObj = { deviceId: ""};
          setLoading(true);
          getEncryptKey(reqObj)
            .then((encRes) => {
              encrypt(
                 `${totalAmt}`,
                encRes.data
              ).then((encAmount) => {
                let req = {
                  useCase: "tagIssue", tagId: "", mobileNo: null, vehicleClass: props?.data?.addVehicleData?.vehicleClass, amount: encAmount,
                  platform: "FF_PORTAL", tripInsurancePolicyCode:props?.data?.insuranceSkipped ? "" : props?.data?.policyInfo?.planId, isRecurringPolicy:props?.data?.policyInfo?.recurring
                };
                getPaymentData(req)
                  .then((res) => {
                    if ( res.statusCode < 0 || res.statusCode == 500 || res.statusCode == 400 || res.statusCode == -1017 ) {
                      setAlertModal({title: "Error", status: "error", message: res.message,  navigateScreen: "", actionButton: "OK"});
                      setAlertModalVisible(true);
                      setLoading(false);
                    } else {
                      setHTMLDATA(res.response.paymentEncKey);
                      setOrderId(res.response.orderId);
                      AsyncStorageFunc.storeData(
                        "ORDERID",
                        res.response.orderId
                      );
                      if (!props?.data?.insuranceSkipped) {
                        let data = props?.data
                        AsyncStorageFunc.storeData("TI_REQ", {
                          isInsuranceSkipped : false, mobileNo: global?.mobileNo, tagId: "", triggeringMode: "Add-Vehicle",
                          policyInfo: { policyPlanId: data?.policyInfo?.planId, recursiveFlag: data?.policyInfo?.recurring == true ? "Y" : "N", policyStartDate: moment(new Date()).format( "DDMMYYYYHHmmss" )},
                          insuredDetails: {
                            namePrefix:data?.insuredDetails?.prefix,
                            firstName: data?.insuredDetails.firstName, middleName: data?.insuredDetails.middleName, lastName: data?.insuredDetails.lastName,
                            gender: data?.insuredDetails.gender == "M" ? "Male": data?.insuredDetails?.gender == "F"? "Female" : "Others",
                            dob: moment(data?.insuredDetails?.dob,"DD/MM/YYYY").format("DD-MM-YYYY"),
                            mobileNo: data?.insuredDetails?.mobileNo,  emailId: data?.insuredDetails?.emailId,
                            addressLine1: data?.insuredDetails?.address1, addressLine2: data?.insuredDetails?.address2,
                            city: data?.insuredDetails?.city, state: data?.insuredDetails?.state, pincode: data?.insuredDetails?.zipCode,
                          },
                          nomineeDetails: data.nomineeDetails,
                        });
                      } else AsyncStorageFunc.storeData("TI_REQ", {isInsuranceSkipped : props?.data?.insuranceSkipped});
                      setLoading(false);
                    }
                  }).catch((err) => {
                    setAlertModal({ title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK"});
                    setAlertModalVisible(true);
                    setLoading(false);
                  });
              });
            }).catch((err) => {
              setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK"});
              setAlertModalVisible(true);
            }); } else {
          setLoading(false);
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK"});
          setAlertModalVisible(true);
        }
      }).catch((err) => {
        setLoading(false);
        setAlertModal({title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK" });
        setAlertModalVisible(true);
      });
  };
  const enableBtn = () => {
    if (pincode.length == 6 && address1.length > 1) { return true; } else { return false;}
  };

  return (
    <View style={styles.container}>
      <View style={styles.stepWidget}>
        <View style={styles.step1}>
          <View style={styles.backBtnWidget}>
            <TouchableOpacity onPress={() => {props.setScreen((props?.data?.insuranceSkipped && props?.data?.fromScreen == "AddVehicle" ) ? "addVehicle" : props?.data?.insuranceSkipped ? "Benifits" : 'NomineeDetails'); }}>
              <Image source={IconBack} style={{height: 19, width: 19, marginLeft: -30, marginRight: 10,}} />
            </TouchableOpacity>
            <Text style={styles.widgetTitle}>Payment Confirmation</Text>
          </View>
          <View style={styles.paymentBreakupTop}>
            <Text style={styles.paymntText}>{props.data.addVehicleData.vrn}</Text> 
            <Text style={styles.paymntText}> ₹ {props?.data?.priceBreakUpData?.card_breakup?.totalAmt}.00  </Text>
          </View>
          <View style={styles.paymentBreakupMdl}>
            <Text style={styles.paymntTextMdl}>Tag Issuance Fee</Text> 
            <Text style={styles.paymntTextMdl}> ₹ {props.data?.priceBreakUpData?.card_breakup.tagIssueFee}.00</Text>
          </View>
          <View style={styles.paymentBreakupMdl}>
            <Text style={styles.paymntTextMdl}>Tag Deposit Fee</Text>
             <Text style={styles.paymntTextMdl}> ₹ {props.data?.priceBreakUpData?.card_breakup.depositAmt}.00  </Text>
          </View>
          <View style={styles.paymentBreakupMdl}>
            <Text style={styles.paymntTextMdl}>Threshold Fee</Text> 
            <Text style={styles.paymntTextMdl}>₹ {props.data?.priceBreakUpData?.card_breakup.thresholdAmt}.00</Text>
          </View>
          <View style={styles.paymentBreakupBtm}>
            <Text style={styles.paymntTextBtm}>Total Payable</Text> 
            <Text style={styles.paymntTextBtmAmnt}> ₹ {totalAmt}.00</Text>
          </View>
          <Image source={updateCardImage(props.data?.priceBreakUpData?.card_breakup?.cardNumber)} resizeMode="contain" style={styles.cardHieghtStyle} />
        </View>
        <View style={styles.step2}>
          <Text style={styles.widgetTitle}></Text>
          <Text style={styles.stepTitle}>Delivery Address</Text>
          {changeAddressData ? 
          <View style={styles.addressWidget}>
          <TouchableOpacity style={styles.changeLinkWidget} onPress={() => {setChangeAddressModalVisible(true)}}> 
           <Text style={styles.changeLink}>Change</Text> 
           </TouchableOpacity>
          <Text style={styles.nameText}> Mr. {props.data?.priceBreakUpData?.address?.userFirstName}{" "} {props.data?.priceBreakUpData?.address?.userLastName} </Text>
          <Text style={styles.adresText}>
            {address1}
            {address2}, -{pincode} +91{" "}
            {mobileNumber}
          </Text>
        </View>
        :
        <View style={styles.addressWidget}>
            <TouchableOpacity style={styles.changeLinkWidget}
              onPress={() => {
                setPincode(" ")
                setAddress1(" ")
                setAddress2(" ")
                setMobileNumber(" ")
                setChangeAddressModalVisible(true)}} > 
                <Text style={styles.changeLink}>Change</Text>
              </TouchableOpacity>
            <Text style={styles.nameText}>
              Mr. {props.data?.priceBreakUpData?.address?.userFirstName}{" "}
              {props.data?.priceBreakUpData?.address?.userLastName}
            </Text>
            <Text style={styles.adresText}>
              {props.data?.priceBreakUpData?.address?.address1} {props.data?.priceBreakUpData?.address?.city}-{" "}
              {props.data?.priceBreakUpData?.address?.state}
              {props.data?.priceBreakUpData?.address?.zipCode}, +91{" "}
              {props.data?.priceBreakUpData?.address?.mobileNo}
            </Text>
          </View>}
          <View style={{ alignSelf: "flex-end" }}>
            <CustomButton onPress={() => handleSubmit()} text={"Pay Now"} disable={true} style={styles.buttonContainerStyle} />
          </View>
        </View>
      </View>
      {HTMLDATA && HTMLDATA != "" && (
        <View style={styles.overlayViewStyle}>
          <View style={applicationStyles.overlayIinlineModal}>
            <View style={styles.alertModalOverlay} >
              <Image source={require("../../assets/images/Success.png")} style={applicationStyles.iconSuccesIinlineModal}/>
              <Text style={[[applicationStyles.titleIinlineModal,{paddingHorizontal:30,textAlign:'center'}]]}>You will be redirected to payment gateway Click OK to proceed</Text>
              <View style={applicationStyles.footerIinlineModal}>
                <TouchableOpacity
                  onPress={() => {
                    setHTMLDATA("");
                    Linking.openURL(`${global.CC_AVENUE_URL}${HTMLDATA}&access_code=${global.ccavenueAccessCode}`);}}
                    style={applicationStyles.footerBtnIinlineModal}>
                  <Text style={applicationStyles.footerLinkIinlineModal}>  {" "} OK </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      )}
      {otpModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text> 
                <Text style={styles.otpDescTextStyle}>{mobileOtpMsg}</Text>
                <View style={{width:'100%', alignItems:'center', marginTop:10}}>
                <CustomInput onValueChanged={e=>setOtp(e)} value={otp} style={styles.otpInputViewStyle} requiredEndText={true} keyboardType="numeric" pattern={/^\d{6}$/} errorMessage={"Enter Valid OTP"} maxLength={6} />
                </View>
                <View style={styles.resendViewStyle}>
                  <Countdown ref={counterRef} date={timerState.currentTime} key={timerState.currentTimeIndex} onComplete={completeTime} intervalDelay={0} precision={3} renderer={timerRenderer}  />
                </View>
                <View style={styles.btnWrapper}>
                  <CustomButton text={"Submit"} onPress={!otpPattern.test(otp) ? ()=>{} : validateOTP} disable={!otpPattern.test(otp) ? true : false} />
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
       {changeAddressModalVisible ? (
        <View style={[styles.overlayViewStyle,]}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={[styles.overlayContentViewStyle,{width:'90%'}]}>
                <Text style={styles.enterOtpTextStyle}>{"Change Delivery Address"}</Text>
                <View style={{marginVertical:10, alignItems:'center'}}>
                <View style={styles.inputGroupWidget}>
                <View style={[styles.inputGroup,{paddingTop:30}]}>
                  <Text style={[styles.inputLable,{marginTop:-30}]}>{"Pincode"}
                   <Text style={styles.mandatoryText} >  {" *"}</Text> 
                   </Text>
                  <View>
                  <CustomInput onValueChanged={text => setPincode(text)} value={pincode} requiredEndText={true}  errorMessage={""} />
                {!address.District && !address.State && pincode != "" ? (
                <Text style={styles.errorText} > {"Please enter valid pincode"}</Text> ) : null}
                <Text style={[ styles.transactTxt, { fontSize:13, padding: 5, marginBottom: 10 } ]}> {address && address.District ? address.District + ", " + address.State : ""} </Text>
                </View>
                </View>
                  <View style={styles.inputGroup}> 
                      <Text style={[styles.inputLable,{marginTop:0}]}>{"Address Line 1"} 
                        <Text style={styles.mandatoryText} >{" *"} </Text>
                      </Text>
                    <CustomInput onValueChanged={text => setAddress1(text)} value={address1} requiredEndText={true}  errorMessage={""} />
                  </View>
                </View>
                <View style={styles.inputGroupWidget}>
                  <View style={styles.inputGroup}>
                    <Text style={styles.inputLable}>{"Address Line 2"}</Text>
                    <CustomInput  onValueChanged={text => setAddress2(text)} value={address2} requiredEndText={true} errorMessage={""} />
                  </View>
                 <View style={styles.inputGroup}>
                   <Text style={styles.inputLable}>{"Contact Number"}</Text>
                  <CustomInput onValueChanged={text => setMobileNumber(text)} value={mobileNumber} requiredEndText={true} errorMessage={""} maxLength={10} />
                 </View>
                </View> </View>
                <View style={styles.addressFooterWidget} >
                  {enableBtn() && address.District && address.State ? <CustomButton text={"Update"} onPress={() => onChangeAddress()} /> : 
                  <CustomButton text={"Update"} disable={true} /> }
                  <View style={styles.btnSpace}> <TouchableOpacity style = {styles.manageAutoButton} onPress={() => setChangeAddressModalVisible(false)} >   
                   <Text style = {styles.mabLabel}>{"Cancel"} </Text>
                    </TouchableOpacity> 
                    </View>
                </View>
              </View> 
              </View> </View>
        </View>
      ) : null}
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
    </View>
  );
}

